import type { Component } from '@/composition/vue/compositionApi'
import type { RegisteredServices } from '@/core/container/types'
import type { TmWrappers } from '@/wrappers'
import type { CustomFieldSchemaFormData } from '@/services/forms/customFieldSchemaFormService'
import type { CustomFieldType } from '@/services/domain/cusomFields/types'
import type { ComponentProps } from '@/composition/types'

export const selectingContactsId: TmWrappers = 'selectingContacts'
export const selectingContactsProgressId: TmWrappers = 'selectingContactsProgress'
export const selectingContactsListsId: TmWrappers = 'selectingContactsLists'
export const selectingSegmentsId: TmWrappers = 'selectingSegments'
export const UnsubscribeContactModal: TmWrappers = 'UnsubscribeContactModal'

export const contactListBulkDeleteModal: TmWrappers = 'contactListBulkDeleteModal'
export const ContactListTable = 'ContactListTable' as RegisteredServices
export const ContactListTempDetailsTable = 'ContactListTempDetailsTable' as RegisteredServices
export const ContactsTable = 'ContactTable' as RegisteredServices
export const ListTable = 'ListTable' as RegisteredServices
export const AllContactListTable = 'AllContactListTable' as RegisteredServices
export const ContactImportsTable = 'ContactImportsTable' as RegisteredServices
export const UnsubscribedTable = 'UnsubscribedTable' as RegisteredServices
export const BlockedContactsTableId = 'BlockedContacsTable' as RegisteredServices
export const ListIdRouteParam = 'contactListId'
export const contactImportIdRouteParam = 'importId'
export const SelectingContactsTable = 'SelectingContactsTable' as RegisteredServices
export const SelectingContactsListsTable = 'SelectingContactsListsTable' as RegisteredServices
export const SegmentsTableId = 'SegmentsTable' as RegisteredServices
export const SelectingSegmentsTable = 'SelectingSegmentsTable' as RegisteredServices
export const CustomFieldsSchemaModalId = 'customFieldsSchemaModal' as const
export const CustomFieldsTableIdNew = 'customFieldsTableNew' as const

export const addContactsChooseSourceModal: TmWrappers = 'addContactsChooseSourceModal'

export type CustomFieldSchemaModalSlotItem<C extends Component = Component> = {
  component: C
  props: ComponentProps<C>
}

export type CustomFieldSchemaModalSlots = {
  disabledTypePlaceholder?: CustomFieldSchemaModalSlotItem
}

export type CustomFieldSchemaModalParams = {
  editingId?: string
  onSuccessCallback?: (formData: CustomFieldSchemaFormData) => void
  allowedTypes?: CustomFieldType[]
  slots?: CustomFieldSchemaModalSlots
}
